export default {
  getIconName(route, icon, active) {
    const isActive = active.name?.startsWith(route);
    const iconType = isActive ? 'fill' : 'line';

    return `${icon}-${iconType}`;
  },
};
